import Vue from 'vue';
import VueMatomo from 'vue-matomo';
import Vuelidate from 'vuelidate';
import {sync} from 'vuex-router-sync';

import App from './App.vue';
import vuetify from './core/plugins/vuetify';
// import './registerServiceWorker';
import router from './core/router';
import {store} from './core/store';

declare module 'particles.vue';

sync(store, router);

Vue.use(Vuelidate);

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueMatomo, {
    host: 'https://impactiv.matomo.cloud',
    siteId: 3,
    router,
    requireCookieConsent: true,
  });
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
